/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import allActions from '../../actions';
import Loading from '../../components/loading/Loading';
import { USE_WORKLIST_VIEW } from '../../utils/GlobalConstants';
import MaterialListContainer from '../MaterialListView/MaterialListContainer';
import { modes } from '../MaterialListView/utils/MaterialListFunctions';

function WorklistContainer() {
  const { worklistID } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const worklistDetails = useSelector((state) => state.worklistState.worklistDetails?.[0]);
  const materialLoading = useSelector((state) => state.materialState.isLoadingData);
  const materialViewStore = useSelector((state) => state.materialState.localMaterialViewStore);
  const [detailsResolved, setDetailsResolved] = useState(false);
  const [viewState, setViewState] = useState({
    sortColumn: null,
    sortDirection: null,
    searchFilters: null,
  });
  useEffect(() => {
    if (worklistID) {
      dispatch(allActions.WorkListActions.fetchWorklistDetails(worklistID));
    }
  }, [worklistID]);

  useEffect(() => {
    if (worklistDetails?.SelectedColumns?.length > 0 && worklistDetails?.WorklistID === worklistID) {
      dispatch(allActions.MaterialListActions.selectView(USE_WORKLIST_VIEW));
      setDetailsResolved(true);
      if (history.location?.state?.prevPath === 'matDetails' && materialLoading === false) {
        setViewState({
          sortColumn: materialViewStore?.sortColumn,
          sortDirection: materialViewStore?.sortDirection,
          searchFilters: materialViewStore?.searchFilters,
        });
      } else {
        const props = {
          sortColumn: worklistDetails?.SortColumn,
          sortDirection: worklistDetails?.SortDirection,
          searchFilters: {},
        };
        if (worklistDetails?.SearchFilters) {
          setViewState({
            ...props,
            searchFilters: JSON.parse(worklistDetails.SearchFilters),
          });
        } else setViewState(props);
      }
    }
  }, [worklistDetails]);

  return (
    detailsResolved
      ? (
        <MaterialListContainer
          worklistID={worklistID}
          worklistDetails={{
            WorklistID: worklistDetails?.WorklistID,
            WorklistName: worklistDetails?.WorklistName,
            WorklistDescription: worklistDetails?.WorklistDescription,
            CreatedDate: worklistDetails?.CreatedDate,
            ModifiedDate: worklistDetails?.ModifiedDate,
            CreatedBy: worklistDetails?.CreatedBy,
            ModifiedBy: worklistDetails?.ModifiedBy,
            IsWorklistShared: worklistDetails?.IsWorklistShared,
            CreatedUserEmail: worklistDetails?.CreatedUserEmail,
            ModifiedByUserEmail: worklistDetails?.ModifiedByUserEmail,
            ListType: worklistDetails?.ListType,
          }}
          headerCells={worklistDetails?.SelectedColumns ? JSON.parse(worklistDetails.SelectedColumns) : []}
          mode={modes.DYNAMIC}
          searchFilters={viewState.searchFilters}
          sortColumn={viewState.sortColumn}
          sortDirection={viewState.sortDirection}
        />
      )
      : <Loading text="Loading Worklist" />
  );
}

WorklistContainer.propTypes = {

};

export default WorklistContainer;
